import { create } from 'zustand';
import { createDI } from '../../../context/di/di';
import { ApiError, useApi } from '../../../api/api';
import { NotificationListReponse } from '../../../model/notification_response';

/**
 * 通知一覧画面 アクションを管理するための DI コンテキスト(アクション)
 */
export type NotificationAction = {
  /**
   * 通知一覧取得
   */
  getNotification: () => Promise<NotificationListReponse>;
};

/**
 * 通知一覧画面 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, use] = createDI<NotificationAction>();
export { Provider as NotificationProvider, use as useNotificationStore };

/**
 * 通知一覧画面 状態とアクション
 */
export const defaultNotificationStore = () => {
  const api = useApi();

  return create<NotificationAction>(() => {
    return {
      getNotification: async () => {
        const resp = await api.path('/api/notification').get();
        if (resp.isError) {
          throw new ApiError(resp);
        }
        return resp.data as NotificationListReponse;
      },
    };
  });
};
